// extracted by mini-css-extract-plugin
export default {"text":"DeletePublicPasswordDialog__text--2pNG8","dialog":"DeletePublicPasswordDialog__dialog--1hsN6"};